import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { List, Button, Popconfirm } from "antd";
import { HEAD_DEFAULT, MyIcon } from "../../common/baseConfig";
import moment from "moment";
import NoneData from "../common/NoneData";
import ExerRecordPane from "./ExerRecordPane";

export class ExerRecordMyNote extends Component {
  state = {
    curPage: 1,
    questionType: -1,
    questionTypeName: "",
    checkIndex: -1,
  }
  static propTypes = {
    center: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentDidMount() {
    this.props.actions.fetchGetQuestionTypeList().then(res => {
      if (res.SuccessResponse) {
        this.setState({
          questionType: res.Data[0].ID,
          questionTypeName: res.Data[0].Name
        }, () => {
          this.onLoadMyNote();
        })
      }
    })
  }
  onLoadMyNote() {
    this.props.actions.fetchGetMyNote({
      PageSize: 5,
      PageIndex: this.state.curPage,
      PageStatus: 1,
      QuestionType_ID: this.state.questionType,
    })
  }
  onNoteClick(data) {
    this.setState({
      curPage: 1,
      questionType: data.ID,
      questionTypeName: data.Name
    }, () => {
      this.onLoadMyNote();
    })
  }
  delNote(noteID) {
    //删除单挑笔记
    this.props.actions.fetchDeleteNoteById({
      ID: noteID,
    }).then(res => {
      if (res.SuccessResponse) {
        this.onLoadMyNote();
      }
    })
  }
  renderItem(item, key, questionTypeName) {
    const studentinfo = JSON.parse(localStorage.getItem("studentinfo"));
    const { checkIndex } = this.state;
    return (
      <div key={key} className="note-collect-item">
        <div className="note-collect-item-content">
          <div className="content">
            <img src={studentinfo.HeadImg || HEAD_DEFAULT} alt="" />
            <h1>
              <p className="p1">
                <span>{studentinfo.Name || "未知"}</span>
                <span>
                  {moment(new Date(item.NoteList[0].AddTime)).format("YYYY-MM-DD HH:mm:ss")}
                </span>
              </p>
              <p className="p2">
                {item.NoteList[0].Remart}
              </p>
              <p className="p3">
                来源:【{questionTypeName}】<span dangerouslySetInnerHTML={{ __html: item.Title }} />
              </p>
            </h1>
          </div>
          <div className="btns">
            <Button type="theme" className="btn" onClick={() => {
              if (checkIndex === item.ID) {
                this.setState({
                  checkIndex: -1,
                })
              } else {
                this.setState({
                  checkIndex: item.ID,
                })
              }
            }}>{checkIndex === item.ID ? "收起题目" : "查看题目"}</Button>
            <Popconfirm placement="topRight" title={"确认删除该单条笔记吗？"} onConfirm={this.delNote.bind(this, item.NoteList[0].ID)} okText="确认" cancelText="取消">
              <p className="del"><MyIcon type="iconshanchu1" /></p>
            </Popconfirm>
          </div>
        </div>
        {
          checkIndex === item.ID && <ExerRecordPane
            {...this.props}
            item={item}
            questionTypeName={questionTypeName}
            onLoad={this.onLoadMyNote.bind(this)}
          />
        }
      </div>
    )
  }
  render() {
    const { fetchGetQuestionTypeListSuccess,
      fetchGetMyNotePending,
      fetchGetMyNoteSuccess,
      fetchGetMyNoteTotal,
    } = this.props.center;
    const { questionType, questionTypeName, } = this.state;
    return (
      <div className="center-exer-record-my-note">
        <div className="inner">
          {
            fetchGetQuestionTypeListSuccess && fetchGetQuestionTypeListSuccess.length > 0 &&
            <div className="note-type">
              {
                fetchGetQuestionTypeListSuccess.map(item => (
                  <div
                    key={item.ID}
                    onClick={this.onNoteClick.bind(this, item)}
                    className={questionType === item.ID ? "note-type-item-active" : "note-type-item"}
                  >
                    {item.Name}
                  </div>
                ))
              }

            </div>
          }
          {
            fetchGetMyNoteSuccess && fetchGetMyNoteSuccess.length > 0 &&
            <div className="note-collect-list">
              <List
                itemLayout="horizontal"
                size="large"
                pagination={{
                  onChange: page => {
                    this.setState({
                      curPage: page,
                    }, () => {
                      this.onLoadMyNote();
                    })
                  },
                  current: this.state.curPage,
                  total: fetchGetMyNoteTotal,
                  pageSize: 5,
                }}
                loading={fetchGetMyNotePending}
                dataSource={fetchGetMyNoteSuccess}
                renderItem={(item, key) => this.renderItem(item, key, questionTypeName)}
              />
            </div>
          }
          {
            fetchGetMyNoteSuccess && fetchGetMyNoteSuccess.length === 0 &&
            <div className="noneData">
              <NoneData type={2} />
            </div>
          }
        </div>

      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    center: state.center,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExerRecordMyNote);



// WEBPACK FOOTER //
// ./src/features/center/ExerRecordMyNote.js